<template>
	<card>
		<template slot="header">
			<h4 class="mb-0">รายการสมัครสมาชิก <small>(รายชั่วโมง)</small></h4>
		</template>
		<template>
			<bar-chart :height="250" :chart-data="chartData" :extra-options="extraOptions" />
		</template>
	</card>
</template>

<script>
import BarChart from '../../components/Charts/BarChart'

import { Charts } from '../../components/Charts/config'

export default {
	props: ['data'],
	components: {
		BarChart,
	},
	data() {
		return {
			chartData: {},
			extraOptions: {
				responsive: true,
			},
		}
	},
	methods: {
		updateChart(v) {
			this.chartData = {
				labels: [
					'00:00',
					'01:00',
					'02:00',
					'03:00',
					'04:00',
					'05:00',
					'06:00',
					'07:00',
					'08:00',
					'09:00',
					'10:00',
					'11:00',
					'12:00',
					'13:00',
					'14:00',
					'15:00',
					'16:00',
					'17:00',
					'18:00',
					'19:00',
					'20:00',
					'21:00',
					'22:00',
					'23:00',
				],
				datasets: [
					{
						label: 'จำนวนสมัครสมาชิก',
						backgroundColor: Charts.colors.theme['success'],
						data: Object.values(v.countHours),
					},
				],
			}
		},
	},
	created() {
		this.updateChart(this.data)
	},
	watch: {
		data(v) {
			this.updateChart(v)
		},
	},
}
</script>
